type Props = {
  icon: React.ReactNode
  title: string
  active?: boolean
}

export const MenuItem: React.FC<Props> = ({ icon, title, active = false }) => {
  console.log(active, 'new link')
  return (
    <div
      data-active={active}
      className='relative flex gap-2 items-center text-black
    hover:text-gpa-blue-500 data-[active=true]:text-gpa-blue-500
    hover:bg-blue-50 data-[active=true]:bg-blue-50 mx-3 px-3 py-2
      rounded-md'
    >
      <span
        data-active={active}
        className='absolute top-1/2 -translate-y-1/2 left-0 scale-0
        data-[active=true]:scale-100 w-[3px] bg-gpa-blue-500 h-4 rounded-tr-sm
        rounded-br-sm'
      ></span>
      <div className='shrink-0'>{icon}</div>
      <span>{title}</span>
    </div>
  )
}
